export default __webpack_public_path__ + "static/recorlev-logics-dosing-guidelines-steps-mobile-06c42d6221a1ec003b493d6327d60812.svg";